import { Box, Button, Theme, Typography, useMediaQuery } from '@mui/material';
import { AmplitudeEvent, trackAmplitudeEvent } from '@/lib/analyticsHelper';
import { ScreenName, ScreenTemplate } from '@/constants';

interface ModalProp {
  enrollmentURL: string;
}

const PetCareModal = ({ enrollmentURL }: ModalProp) => {
  const isMobileOrSmaller = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  const petCareNeeds = ['1', '2', '3+'];

  const handleModalButton = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const amplitudeData = {
      asset_type: 'Lightbox',
      CTA: e.currentTarget.textContent,
      screen_name: ScreenName.SEGMENTATION,
      screen_template: ScreenTemplate.SEGMENTATION,
    };

    trackAmplitudeEvent(AmplitudeEvent.monetateAssetClicked, amplitudeData);
  };

  return (
    <>
      <Typography
        align="center"
        display="block"
        mb={1}
        color="textSecondary"
        variant="body2"
        component="span">
        Tell us about your needs!
      </Typography>
      <Typography
        align="center"
        display="block"
        color="textSecondary"
        variant={isMobileOrSmaller ? 'h2' : 'h1'}
        component="span"
        mb={3}
        letterSpacing="-1px">
        How many pets need care?
      </Typography>
      <Box
        sx={(theme) => ({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          margin: 'auto',
          width: '50%',
          [theme.breakpoints.up('sm')]: {
            width: '42%',
          },
        })}>
        {petCareNeeds.map((count) => (
          <Button
            color="secondary"
            size="large"
            key={count}
            sx={{
              '& + &': {
                marginTop: 2,
              },
              '&:nth-of-type(3)': {
                marginBottom: -2,
              },
            }}
            variant="outlined"
            fullWidth
            component="a"
            onClick={handleModalButton}
            href={`${enrollmentURL}`}
            rel="nofollow">
            {count}
          </Button>
        ))}
      </Box>
    </>
  );
};

export default PetCareModal;
